import { render, staticRenderFns } from "./afterSaleConfig.vue?vue&type=template&id=8fb69b82&scoped=true"
import script from "./afterSaleConfig.vue?vue&type=script&lang=js"
export * from "./afterSaleConfig.vue?vue&type=script&lang=js"
import style0 from "./afterSaleConfig.vue?vue&type=style&index=0&id=8fb69b82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb69b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb69b82')) {
      api.createRecord('8fb69b82', component.options)
    } else {
      api.reload('8fb69b82', component.options)
    }
    module.hot.accept("./afterSaleConfig.vue?vue&type=template&id=8fb69b82&scoped=true", function () {
      api.rerender('8fb69b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/afterSaleConfig.vue"
export default component.exports